'use strict'

const ESTADO_CIVIL_BY_SEXO = [
  {
    nome_masculino: 'SEPARADO',
    nome_feminino: 'SEPARADA',
  },
  {
    nome_masculino: 'SOLTEIRO',
    nome_feminino: 'SOLTEIRA',
  },
  {
    nome_masculino: 'CASADO',
    nome_feminino: 'CASADA',
  },
  {
    nome_masculino: 'VIUVO',
    nome_feminino: 'VIUVA',
  },
  {
    nome_masculino: 'DIVORCIADO',
    nome_feminino: 'DIVORCIADA',
  },
  {
    nome_masculino: 'DIVORCIADO',
    nome_feminino: 'DIVORCIADA',
  }
]

export function getEstadoCivilBySexo (nomeEstadoCivil, sexo) {
  const estadoCivilBySexo = ESTADO_CIVIL_BY_SEXO.find(ec => ec.nome_masculino === nomeEstadoCivil)
  
  if (!estadoCivilBySexo) return nomeEstadoCivil

  if (sexo === 'M') {
    return estadoCivilBySexo.nome_masculino
  }

  if (sexo === 'F') {
    return estadoCivilBySexo.nome_feminino
  }

  return nomeEstadoCivil
}

